<template>
  <v-container fluid fill-height grid-list-md text-xs-center>
    <v-layout wrap align-center justify-center fill-height>
      <v-flex xs12 md3>
        <v-layout justify-center class="pa-3">
          <v-img :src="this.logoUrl" width="200" v-if="!!this.logoUrl"></v-img>
          <h1 v-else class="text-xs-center" :style="`font-size: 45px; color: ${ logoColor }`">{{ this.company }}</h1>
        </v-layout>
      </v-flex>

      <v-flex xs12 md3>
        <h1>{{ $t('login') }}</h1>
        <v-form @submit.prevent="submit">
          <v-text-field
            v-model="email"
            :label="$t('attrs.email')"
            v-validate="'required|email'"
            :error-messages="errors.collect('email')"
            data-vv-name="email"
            :data-vv-as="$t('attrs.email')"
            required
          ></v-text-field>

          <v-text-field
            v-if="showPassword"
            v-model="password"
            type="text"
            :label="$t('attrs.password')"
            v-validate="'required|max:35'"
            :error-messages="errors.collect('password')"
            data-vv-name="password"
            :data-vv-as="$t('attrs.password')"
            required
          >
            <template v-slot:append>
              <v-btn color="primary" flat icon @click="togglePassword">
                <font-awesome-icon icon="eye"></font-awesome-icon>
              </v-btn>
            </template>
          </v-text-field>

          <v-text-field
            v-else
            v-model="password"
            type="password"
            :label="$t('attrs.password')"
            v-validate="'required|max:35'"
            :error-messages="errors.collect('password')"
            data-vv-name="password"
            :data-vv-as="$t('attrs.password')"
            required
          >
            <template v-slot:append>
              <v-btn color="primary" flat icon @click="togglePassword">
                <font-awesome-icon icon="eye-slash"></font-awesome-icon>
              </v-btn>
            </template>
          </v-text-field>

          <v-btn block color="primary" :loading="loading" type="submit">{{ $t('login') }}</v-btn>

          <a @click="goTo('forgotPassword')">{{ $t('forgotPassword') }}</a>
          <template v-if="hideRegisterUser.value == '0'">
            &nbsp;·&nbsp;

            <a @click="goTo('signup')">{{ $t('signup') }}</a>
          </template>
          <br />
          <a @click="goTo('confirmation')">{{ $t('resendConfirmationEmail') }}</a>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import Setting from '@/client/setting'

export default {
  name: 'LoginView',

  data () {
    return {
      loading: false,
      email: '',
      password: '',
      hideRegisterUser: {},
      logoColor: process.env.VUE_APP_COLOR,
      showPassword: false
    }
  },

  methods: {
    ...mapActions(['login']),

    async submit () {
      this.errors.clear()
      try {
        const isValid = await this.$validator.validateAll()
        if (!isValid) { return }

        this.loading = true
        await this.login({
          email: this.email,
          password: this.password
        })
        this.goTo('dashboard')
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    togglePassword () {
      this.showPassword = !this.showPassword
    }
  },

  async mounted () {
    this.hideRegisterUser = await Setting.register_user_flag()
  }
}
</script>
